var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"\n    flex\n    items-center\n    justify-center\n    font-bold font-sans\n    rounded-full\n    ring-2 ring-white\n    text-white\n  ",class:_vm.bgcolor},[_vm._v(" "+_vm._s(_vm.chars)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }